import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { SharedTranslocoModule } from '@schaeffler/transloco';

import { ApplicationInsightsService } from './services/application-insights.service';
import { pageHeaderI18nProviders } from './shared/layout/page-header/i18n/translations';
import { PageHeaderComponent } from './shared/layout/page-header/page-header.component';
import { UserHeaderService } from './shared/services/user-header.service';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'stop-root',
  templateUrl: './app.component.html',
  imports: [RouterModule, PageHeaderComponent, SharedTranslocoModule],
  providers: [...pageHeaderI18nProviders],
})
export class AppComponent {
  title = 'Stop Web Portal';

  private readonly appInsights = inject(ApplicationInsightsService);
  private readonly router = inject(Router);
  private readonly userHeader = inject(UserHeaderService);

  readonly username = this.userHeader.username;
  readonly initials = this.userHeader.initials;
  readonly userMenuOpen = signal(false);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  public readonly isAuthRoute = computed(() => {
    const currentPath = this.currentUrl();
    return (
      currentPath.startsWith('/login') || currentPath.startsWith('/logout')
    );
  });

  public toggleUserMenu(): void {
    this.userMenuOpen.set(!this.userMenuOpen());
  }

  public closeUserMenu(): void {
    this.userMenuOpen.set(false);
  }

  public logout(): void {
    void this.router.navigateByUrl('/logout');
  }
}
